import { IResearchProductivity } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IResearchProductivityRange {
  from?: string;
  to?: string;
}

export const getResearchProductivity = async ({
  from,
  to,
}: IResearchProductivityRange): Promise<IResearchProductivity> => {
  const response = await apiClient.get("/research/productivity", {
    params: { from: from || undefined, to: to || undefined },
  });

  return response.data;
};
